import ApplianceRender from "../ApplianceRender";

const Kitchen = () => {
    return (
        <ApplianceRender roomName={"Kitchen"}/>
    )
}
export default Kitchen